<template>
  <div class="ListMigracoes">
    <HeaderPage>
      <el-button
        v-if="$can('1|2')"
        style="height: 40px; margin-left: 1rem"
        @click="$router.push({ name: 'config.ListMigracoes.create' })"
      >
        <span>Migrar MarketPlaces</span>
      </el-button>
    </HeaderPage>

    <el-card
      shadow="never"
      :body-style="{ padding: '10px' }"
      style="
        margin: 0 auto 0 auto;
        background-color: transparent;
        border: none;
        max-width: 1200px;
        min-height: auto;
      "
    >
      <ViewCounts />
    </el-card>

    <el-card v-loading="loadingPage" style="max-width: 1200px; margin: 22px auto 0 auto">
      <h4 style="text-align: center; padding: 15px">Listagem de Migrações</h4>
      <!-- <FilterBox /> -->
      <TableSimple :list-data="listData" @paginationClick="paginationClick">
        <el-table-column prop="id" label="ID" width="50" />
        <el-table-column prop="marketplace_name_store_external" label="Nome" />
        <el-table-column prop="status" label="Status">
          <template slot-scope="scope">
            <tagStatus :status="scope.row.status" />
          </template>
        </el-table-column>
        <el-table-column prop="started_in" label="Iniciado em">
          <template slot-scope="scope">
            {{ scope.row.started_in }}
          </template>
        </el-table-column>
        <el-table-column prop="finished_in" label="Finalizado em" />
        <el-table-column prop="migration_step_status.name" label="Etapa Migração" />
        <el-table-column label="Ação" width="100">
          <template slot-scope="scope">
            <el-button
              type="text"
              @click="
                () => {
                  $router.push({
                    name: 'config.ListMigracoes.edit',
                    params: { id: scope.row.id },
                  });
                }
              "
            >
              <EditIcon size="1.2x" style="padding: 0 7px"></EditIcon>
            </el-button>
          </template>
        </el-table-column>
      </TableSimple>
    </el-card>
  </div>
</template>
<script>
import HeaderPage from "@/app/components/HeaderPage";
// import FilterBox from "@/app/components/FilterBox";
import ViewCounts from "@/app/domains/Config/components/Migracao/ViewCounts";
import TableSimple from "@/app/components/Table/TableSimple";
import { SearchMarketplaceMigrado } from "@/app/domains/Config/services";
import { EditIcon } from "vue-feather-icons";
import tagStatus from "@/app/components/Table/TagStatus";

export default {
  name: "TesteComponent",
  components: {
    HeaderPage,
    TableSimple,
    // FilterBox,
    ViewCounts,
    EditIcon,
    tagStatus,
  },
  data() {
    return {
      loadingPage: false,
      listData: {},
    };
  },
  methods: {
    init() {
      this.listDados();
    },
    paginationClick(arg) {
      this.listDados("?page=" + arg.page);
    },
    async listDados(query = "") {
      this.loadingPage = true;
      try {
        let response = await SearchMarketplaceMigrado(query);
        this.listData = response.data;
        
      } catch (e) {
        this.$message({
          showClose: true,
          message: "Erro ao carregar listagem",
          type: "error",
        });
      } finally {
        this.loadingPage = false;
      }
    },
  },
  mounted() {
    this.init();
  },
};
</script>
